<template>
<v-card>
  <v-card-title>Delete song</v-card-title>
  <v-card-text>
    You're about to delete song "{{ title }}". Are you sure you want to proceed?
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" text @click="close">
      Cancel
    </v-btn>
    <v-btn
      color="red darken-1"
      text
      @click="confirm"
    >
      Delete
    </v-btn>
    <v-spacer></v-spacer>
  </v-card-actions>
</v-card>
</template>

<script>
export default {
  name: "SongDeleteCard",
  props: [
    "title",
    "close",
    "confirm",
  ],
}
</script>
